
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[insuranceType]/useful-documents",
      function () {
        return require("private-next-pages/[insuranceType]/useful-documents/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[insuranceType]/useful-documents"])
      });
    }
  